import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function GuaranteeSection() {
  return <section className="py-12 md:py-14 px-6 bg-cream" data-id="element-29">
      <div className="max-w-2xl mx-auto" data-id="element-30">
        <FadeIn data-id="element-31">
          <div className="bg-navy rounded-2xl border border-gold/20 p-8 md:p-10 text-center" data-id="element-32">
            <div className="text-4xl mb-4" data-id="element-33">🛡️</div>

            <h2 className="font-serif text-xl md:text-2xl font-bold text-gold mb-5" data-id="element-34">
              Garantía de Gracia — 7 días
            </h2>

            <div className="space-y-0.5 mb-5" data-id="element-35">
              <p className="text-base text-cream/80 leading-relaxed" data-id="element-36">
                Si aplicaste el protocolo los primeros
              </p>
              <p className="text-base text-cream/80 leading-relaxed" data-id="element-37">
                3 días y no sentiste ningún cambio,
              </p>
              <p className="text-base text-cream/80 leading-relaxed" data-id="element-38">
                escríbeme.
              </p>
            </div>

            <div className="space-y-1 mb-5" data-id="element-39">
              <p className="text-lg font-bold text-cream" data-id="element-40">Sin formularios.</p>
              <p className="text-lg font-bold text-cream" data-id="element-41">
                Sin preguntas incómodas.
              </p>
              <p className="text-lg font-bold text-cream" data-id="element-42">
                Te devuelvo cada centavo.
              </p>
            </div>

            <div className="mb-4" data-id="element-43">
              <p className="text-sm italic text-cream/50 leading-relaxed" data-id="element-44">
                Porque si esto no te mueve,
              </p>
              <p className="text-sm italic text-cream/50 leading-relaxed" data-id="element-45">
                no merezco tu dinero.
              </p>
            </div>

            <p className="text-xs text-gold/60 tracking-wider" data-id="element-46">— InerciaCero</p>
          </div>
        </FadeIn>
      </div>
    </section>;
}